export default {"src":"/_next/static/media/boxing.88702648.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};